module.exports = __webpack_public_path__ + "media/application/images/2025/title-3000-580fbbd81c5901cb2f35528c4b0ee01c.png";